<template>
  <div class="table-responsive">
    <table class="table pdf-item container" style="width: 1083px">
      <thead class="cabecalho" style="background-color: #fff">
        <tr>
          <th scope="col">Operadora</th>
          <th scope="col">Serviço</th>
          <th scope="col">Dependência</th>
          <th scope="col" class="text-center">Quantidade</th>
          <th scope="col" class="text-left text-md-right">Valor Unitário</th>
          <th scope="col" class="text-left text-md-right">Valor Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>{{ item.operadora }}</td>
          <td>{{ item.servico }}</td>
          <td>{{ item.dependencia }}</td>
          <td class="text-center">{{ item.quantidade }}</td>
          <td class="text-left text-md-right">
            {{ item.vlrunitario | currency }}
          </td>
          <td class="text-left text-md-right">
            {{ item.vlrtotal | currency }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "List",
  props: {
    items: Array,
  },
  filters: {
    currency(valor) {
      if (isNaN(valor)) {
        return "-";
      } else {
        var formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        return formatter.format(valor);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.pdf-content {
  th {
    font-size: 14px;
    font-weight: 800;
    padding: 5px;
    padding-bottom: 10px;
    border-bottom: solid 2px lightgrey;
  }
  td {
    font-size: 13px;
    font-weight: 700;
    padding: 2px;
  }
  .cabecalho {
    font-weight: 800;
  }
  tr:nth-child(even) {
    background: #fff;
  }
  tbody > tr:nth-of-type(odd) {
    background: #fff;
  }
  table {
    margin-bottom: -20px;
  }
}
</style>
